import React from 'react';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AuthProvider from './auth/AuthProvider';
import { ThemeProvider } from './theme';
import './styles/theme.css';
import './styles/print.css';
import { logger } from './lib/logger';

logger.log('[env] REACT_APP_AUTH_ENABLED =', process.env.REACT_APP_AUTH_ENABLED);

let rootEl = document.getElementById('root');
if (!rootEl) {
  rootEl = document.createElement('div');
  rootEl.id = 'root';
  document.body.appendChild(rootEl);
}

try {
  const { createRoot } = require('react-dom/client');
  const root = createRoot(rootEl);
  root.render(
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
} catch {
  const ReactDOM = require('react-dom');
  ReactDOM.render(
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>,
    rootEl
  );
}